import { configureStore } from '@reduxjs/toolkit';
import  productReducer  from '../features/ProductList/ProductList_Slice';
import authReducer from "../features/Auth/Auth_Slice";
import cartReducer from "../features/Cart/Cart_Slice";
import thunk from 'redux-thunk';
import orderReducer from '../features/Order/orderSlice';
import userReducer from '../features/User/userSlice';
export const store = configureStore({
  reducer: {
    product:productReducer,
    auth:authReducer,
    cart:cartReducer,
    order:orderReducer,
    user:userReducer
  },
  middleware: [thunk],
});
